export const ModalBodyIdentifiers = Object.freeze({
  TenantAdmins: 1,
  AddTenantAdmin: 2,
  TenantProfile: 3
});
export const EditInfoInit = {
  isVisible: false,
  tenantInfo: {
    disabled: false,
    tenantName: '',
    tenantId: -1,
    imageURL: ''
  }
};
export const adminStateData = {
  showPopup: 0,
  showModal: false,
  modalBodyIdentifier: 0,
  editTenantInfo: EditInfoInit,
  toasterConfig: {
    isVisible: false,
    toasterMessage: ''
  },
  tenantAdmins: [],
  passExpMsg: '',
  PasswordUpdateSuccess: 'false'
};
